module.exports = __webpack_public_path__ + "assets/img/1981591928118_.pic_hd.3b1cb230.jpg";